// @ts-nocheck
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.content.addEventListener('toggle', this.onToggle.bind(this));
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.subDetails = this.querySelectorAll('details.mega-menu-link');
    this.subDetailsPositionSeq = 0;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.subDetails.forEach(subDetails =>
      subDetails.addEventListener('click', this.onSubDetailsClick.bind(this))
    );
    this.subDetails.forEach(subDetails =>
      subDetails.addEventListener('toggle', this.onSubDetailsToggle.bind(this))
    );
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
  }

  onSubDetailsClick(event) {
    const activeDetails = event.currentTarget;
    this.subDetails.forEach(subDetails => {
      if (subDetails !== activeDetails && subDetails.hasAttribute('open')) {
        subDetails.removeAttribute('open');
        subDetails.querySelector('summary').setAttribute('aria-expanded', false);
      }
    });
  }

  onSubDetailsToggle(event) {
    const details = event.currentTarget;
    if (!details) return;

    const container = this.querySelector('.mega-menu__list');
    if (!container) return;

    const li = details.closest('li');
    if (!li) return;

    const panel = li.querySelector('.grandchild-list');
    if (!panel) return;

    if (!details.open) {
      panel.classList.add('hidden');
      panel.style.top = '';
      return;
    }

    const liRect = li.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const offsetTop = liRect.top - containerRect.top;

    panel.style.top = `${-offsetTop}px`;
    panel.classList.add('hidden');
    const seq = ++this.subDetailsPositionSeq;
    requestAnimationFrame(() => {
      if (seq !== this.subDetailsPositionSeq) return;
      if (!details.open) return;
      panel.classList.remove('hidden');
    });
  }
}

customElements.define('header-menu', HeaderMenu);

class ZrAccordion extends DetailsDisclosure {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', e => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.mainDetailsToggle.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.mainDetailsToggle.open) {
      this.open();
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.mainDetailsToggle.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;
    // Store the current height of the element
    const startHeight = `${this.mainDetailsToggle.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    // Start a WAAPI animation
    this.animation = this.mainDetailsToggle.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 300,
        easing: 'ease',
      }
    );
    // fade in content
    this.content.style.opacity = 0;
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    // Apply a fixed height on the element
    this.mainDetailsToggle.style.height = `${this.mainDetailsToggle.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.mainDetailsToggle.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.mainDetailsToggle.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    // Start a WAAPI animation
    this.animation = this.mainDetailsToggle.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 300,
        easing: 'ease',
      }
    );
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.mainDetailsToggle.open = open;
    // fade in content
    this.content.style.opacity = 1;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.mainDetailsToggle.style.height = this.mainDetailsToggle.style.overflow = '';
  }
}

customElements.define('zr-accordion', ZrAccordion);
